import GroupAnnouncement from '~/pages/Announcement';

export default GroupAnnouncement;
